import { useParams } from "react-router-dom";
import { MODULES } from "@/config/modules";
import DataModule from "@/components/DataModule";
import { useTenant } from "@/context/TenantContext";

export default function GenericPage() {
  const { entity } = useParams();
  const { company } = useTenant();
  const module = MODULES[entity];
  if (!module) return <div className="text-slate-500">Module not found.</div>;
  return <DataModule key={entity} module={module} currency={company?.currency || "EUR"} />;
}
